import { sidebarIcons } from 'src/layouts/SidebarV2/icons';
import { IconAction, NavItem } from 'src/layouts/SidebarV2/primitives';
import type { FavouriteModel } from 'src/layouts/SidebarV2/types';

export interface FavouriteRowProps {
  item: FavouriteModel;
  onStartChat: (item: FavouriteModel) => void;
  onToggleFavourite: (item: FavouriteModel) => void;
}

const FavouriteRow = ({
  item,
  onStartChat,
  onToggleFavourite
}: FavouriteRowProps) => (
  <NavItem
    name={item.name}
    icon={item.icon}
    avatar={item.avatar}
    to={item.to}
    onClick={item.to ? undefined : () => onStartChat(item)}
    actionCell={
      <>
        {item.canStartChat ? (
          <IconAction
            icon={sidebarIcons.newChat}
            label="Start chat"
            onClick={() => onStartChat(item)}
          />
        ) : null}
        <IconAction
          icon={sidebarIcons.starFilled}
          label="Remove from favourites"
          onClick={() => onToggleFavourite(item)}
        />
      </>
    }
  />
);

export { FavouriteRow };
